export function convertKebabToCamel(kebabString) {
    return kebabString.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });
}
//# sourceMappingURL=convertKebabToCamel.js.map
